import * as fabric from "fabric"; // v6

export function renderCustomIcon(
  ctx: CanvasRenderingContext2D,
  left: number,
  top: number,
  imageElement: HTMLImageElement,
  fabricObject: fabric.Object,
) {
  const size = 24; // Desired size of the icon
  ctx.save();
  ctx.translate(left, top);
  ctx.rotate(fabric.util.degreesToRadians(fabricObject.angle || 0));
  ctx.drawImage(imageElement, -size / 2, -size / 2, size, size);
  ctx.restore();
}

export async function getFileFromCanvas(index: number) {
  const canvasElement = document.getElementById(
    `label-canvas-${index}`,
  ) as HTMLCanvasElement;

  await new Promise((r) => setTimeout(r, 100)); // Wait for any ongoing rendering

  if (!canvasElement) {
    throw new Error(`Canvas label-canvas-${index} was not found`);
  }

  const blob = await new Promise<Blob>((resolve, reject) => {
    canvasElement.toBlob((blob) => {
      if (!blob) {
        reject(new Error("Could not export canvas to PNG"));
        return;
      }
      resolve(blob);
    }, "image/png");
  });

  return new File([blob], "label.png", { type: "image/png" });
}
